// --------------------------------------------------------------------------
// Registration form code - Validation handler
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');
require('../plugins/expressive.annotations.validate');

module.exports = function (options) {
  var context = options.context;

  function init() {
    var $registerForm = context.find('form');
    $registerForm.on('submit', function () {
      if (!$(this).valid()) {
        var $topmostInvalidField = $('.field-validation-error').eq(0);

        // for fields that uses different error class, e.g. the DP opt-in block
        if ($topmostInvalidField.length === 0) {
          $topmostInvalidField = $('.input-validation-error').eq(0) - 100; // add 100 pixels for better visibility of the invalid field
        }

        var scrollTop = $topmostInvalidField.offset().top;
        if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
          window.scrollTo(0, scrollTop);
        } else {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 500);
        }
      }
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/register-form.js
// module id = 209
// module chunks = 0